import React, { useEffect, useState } from "react";
import {
  Modal,
  Spin,
  Tabs,
  Form,
  Select,
  Table,
  Checkbox,
  notification,
  Typography,
} from "antd";
import { CoffeeOutlined } from "@ant-design/icons";
import Api from "../../../../services/ServiceApi";
import JobProgressForm from "../../full_detail_job/detail_section/Job_Progress_Form";

const { Text } = Typography;
const ModalProgressForm = ({ data, onCancel }) => {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const [jobData, setJobData] = useState();
  const { jobId, CompanyId, OperatorId, ProjectId } = data || {};

  useEffect(() => {
    if (data) {
      async function FetchData() {
        Api.post("job_detail/get_job_detail", {
          job_id: jobId,
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        })
          .then((res) => {
            if (res.data.data.job_detail[0]) {
              const dataTocall = res.data.data.job_detail[0];
              Api.post("job_detail/get_job_fulldetail", {
                company_id: CompanyId,
                operator_id: OperatorId,
                project_id: ProjectId,
                job_id: jobId,
                job_progress_id: dataTocall.job_progress_id,
              })
                .then((res) => {
                  setJobData(res.data.data);
                })
                .catch((err) => {
                  setErrorMessage(err.message);
                })
                .finally(() => setTimeout(setLoading(false), 3000));
            } else {
              setErrorMessage("Data not found");
              setLoading(false);
            }
          })
          .catch((err) => {
            setErrorMessage(err.message);
            setLoading(false);
          });
      }
      FetchData();
    }
    return () => {
      setLoading(true);
      setJobData();
    };
  }, [data]);

  return (
    <Modal
      title={null}
      visible={data}
      centered
      footer={null}
      bodyStyle={{ padding: 0 }}
      closable={!loading}
      maskClosable={false}
      onCancel={onCancel}
      className="custom-modal-map-large bbtec-theme"
    >
      <Spin spinning={loading} tip="Loading" size="large">
        <div style={{ backgroundColor: "white", height: 500 }}>
          {errorMessage && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CoffeeOutlined style={{ fontSize: 50 }} />
              <span style={{ fontSize: 20, marginTop: 10 }}>
                {errorMessage}
              </span>
            </div>
          )}
          {jobData && (
            <JobProgressForm
              CompanyId={CompanyId}
              OperatorId={OperatorId}
              ProjectId={ProjectId}
              jobData={jobData}
              isReloadPage={false}
              isCollapsible={false}
              isShowArrow={false}
              onSuccess={() => onCancel()}
              isTitleDetail={true}
            />
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default ModalProgressForm;
